export type AdminPillStatus =
  | 'PUBLISHED'
  | 'DRAFT'
  | 'VALIDATING'
  | 'ARCHIVED'
  | 'SOLD'
  | 'NEW'
  | 'IN_PROGRESS'
  | 'PROCESSED'
  | 'CLOSED'
  | 'ACCEPTED'
  | 'REFUSED'
  | 'ACTIVE';

const STATUS_CLASS: Record<AdminPillStatus, string> = {
  PUBLISHED: 'admin-pill--published',
  DRAFT: 'admin-pill--draft',
  VALIDATING: 'admin-pill--validating',
  ARCHIVED: 'admin-pill--archived',
  SOLD: 'admin-pill--sold',
  NEW: 'admin-pill--new',
  IN_PROGRESS: 'admin-pill--in-progress',
  PROCESSED: 'admin-pill--processed',
  CLOSED: 'admin-pill--closed',
  ACCEPTED: 'admin-pill--accepted',
  REFUSED: 'admin-pill--refused',
  ACTIVE: 'admin-pill--active',
};

export type AdminPillProps = {
  status: AdminPillStatus;
  label: string;
};

export function AdminPill({ status, label }: AdminPillProps) {
  return <span className={`admin-pill ${STATUS_CLASS[status]}`}>{label}</span>;
}
